var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriquestre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4,7.5c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S5.1,7.5,4,7.5z M7,2.5c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2 S8.1,2.5,7,2.5z M10,7.5c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S11.1,7.5,10,7.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriquestre);
export default __webpack_public_path__ + "static/media/triquestre.42028b59.svg";
export { ForwardRef as ReactComponent };